<template>
  <div class="w-100 contq">
    <!-- posts -->
    <div>
      <h3 class="title">Saved Posts</h3>
      <div v-if="loadingpost" class="d-flex justify-content-center">
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div v-if="!loadingpost && favoritePost && favoritePost.length">
        <div v-for="(favorite, index) in favoritePost" :key="index">
          <FavPost
            v-if="favorite.favorite && favorite.favorite.length ? favorite.favorite[0].content_type === 'post' : false"
            :postData="{ ...favorite.favorite[0], postId: favorite.favorite[0].id }"
            v-on:refresh="fetchPost()"
            :fetchPosts="fetchPost"
            :showFullScreen="showFullScreen"
            :handleOtherModals="handleOtherModals"
            :fromProfileSaved="true"
          />
        </div>
        <span
          class="viewmore cp"
          v-if="favoritePost && favoritePost.length < paginationPost.total_count"
          :style="{ color: getPrimaryColor(), textAlign: 'center', display: 'block' }"
          @click="fetchPost(true)"
        >
          More Posts
        </span>
      </div>
      <div v-if="!loadingpost && favoritePost && !favoritePost.length">
        <div class="dailogbox">
          <div class="dailog-wrapper">
            <span class="dailog">
              <span class="dailog text-capitalize">
                {{
                  viewUser.role === "hospital"
                    ? viewUser.hospital_info.hospital_name
                    : viewUser.role === "clinic"
                    ? viewUser.clinic_info.clinic_name
                    : viewUser.doctor_info
                    ? viewUser.doctor_info.full_name
                    : viewUser.display_name
                }}
              </span>
              has not saved any posts yet.
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- questions -->
    <div>
      <h3 class="title">Saved Questions</h3>
      <div v-if="loadingqa" class="d-flex justify-content-center">
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div v-if="!loadingqa && favoriteQA && favoriteQA.length">
        <div v-for="(favorite, index) in favoriteQA" :key="index">
          <Question
            v-if="favorite.favorite && favorite.favorite.length ? favorite.favorite[0].content_type === 'question' : false"
            :quesData="favorite.favorite[0]"
            :showFullScreen="showFullScreen"
            :fetchPosts="fetchQA"
            :fromProfileSaved="true"
          />
        </div>
        <span
          class="viewmore"
          v-if="favoriteQA && favoriteQA.length < paginationQA.total_count"
          :style="{ color: getPrimaryColor(), textAlign: 'center', display: 'block', cursor: 'pointer' }"
          @click="fetchQA(true)"
        >
          More Questions
        </span>
      </div>
      <div v-if="!loadingqa && favoriteQA && favoriteQA.length === 0">
        <div class="dailogbox">
          <div class="dailog-wrapper">
            <span class="dailog">
              <span class="dailog text-capitalize">
                {{
                  viewUser.role === "hospital"
                    ? viewUser.hospital_info.hospital_name
                    : viewUser.role === "clinic"
                    ? viewUser.clinic_info.clinic_name
                    : viewUser.doctor_info
                    ? viewUser.doctor_info.full_name
                    : viewUser.display_name
                }}
              </span>
              has not saved any questions yet.
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- polls -->
    <div>
      <h3 class="title">Saved Polls</h3>
      <div v-if="loadingpoll" class="d-flex justify-content-center">
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div v-if="!loadingpoll && favoritePoll && favoritePoll.length">
        <div v-for="(favorite, index) in favoritePoll" :key="index">
          <UserPollCard
            :fetchPosts="fetchPoll"
            v-if="favorite.favorite && favorite.favorite.length ? favorite.favorite[0].content_type === 'poll' : false"
            :pollData="{ ...favorite.favorite[0], postId: favorite.favorite[0].id }"
            :fromProfileSaved="true"
          />
        </div>
        <span
          class="cp viewmore"
          v-if="favoritePoll && favoritePoll.length < paginationPoll.total_count"
          :style="{ color: getPrimaryColor(), textAlign: 'center', display: 'block' }"
          @click="fetchPoll(true)"
        >
          More Polls
        </span>
      </div>
      <div v-if="!loadingpoll && favoritePoll && favoritePoll.length === 0">
        <div class="dailogbox">
          <div class="dailog-wrapper">
            <span class="dailog">
              <span class="dailog text-capitalize">
                {{
                  viewUser.role === "hospital"
                    ? viewUser.hospital_info.hospital_name
                    : viewUser.role === "clinic"
                    ? viewUser.clinic_info.clinic_name
                    : viewUser.doctor_info
                    ? viewUser.doctor_info.full_name
                    : viewUser.display_name
                }}
              </span>
              has not saved any polls yet.
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- job -->
    <div>
      <h3 class="title">Saved Jobs</h3>
      <div v-if="loadingJob" class="d-flex justify-content-center">
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div v-if="!loadingJob && favoriteJob && favoriteJob.length">
        <div v-for="(favorite, index) in favoriteJob" :key="index">
          <FavPost
            v-if="favorite.favorite && favorite.favorite.length ? favorite.favorite[0].type === 'job' : false"
            :postData="{
              ...favorite.favorite[0],
              content_type: favorite.favorite[0].type,
              postId: favorite.favorite[0].id,
              sponsered: favorite.favorite[0].sponsered ? favorite.favorite[0].sponsered : [],
              user: [favorite.favorite[0].user],
              allow_comments: favorite.favorite[0].allow_comments ? favorite.favorite[0].allow_comments : true,
            }"
            v-on:refresh="fetchJob()"
            :fetchPosts="fetchJob"
            :handleOtherModals="handleOtherModals"
            :fromProfileSaved="true"
          />
        </div>
        <span
          class="viewmore cp"
          v-if="favoriteJob && favoriteJob.length < paginationJob.total_count"
          :style="{ color: getPrimaryColor(), textAlign: 'center', display: 'block' }"
          @click="fetchJob(true)"
        >
          More Jobs
        </span>
      </div>
      <div v-if="!loadingJob && favoriteJob && favoriteJob.length === 0">
        <div class="dailogbox">
          <div class="dailog-wrapper">
            <span class="dailog">
              <span class="dailog text-capitalize">
                {{
                  viewUser.role === "hospital"
                    ? viewUser.hospital_info.hospital_name
                    : viewUser.role === "clinic"
                    ? viewUser.clinic_info.clinic_name
                    : viewUser.doctor_info
                    ? viewUser.doctor_info.full_name
                    : viewUser.display_name
                }}
              </span>
              has not saved any jobs yet.
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- event -->
    <div>
      <h3 class="title">Saved Events</h3>
      <div v-if="loadingEvent" class="d-flex justify-content-center">
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div v-if="!loadingEvent && favoriteEvent && favoriteEvent.length">
        <div v-for="(favorite, index) in favoriteEvent" :key="index">
          <FavPost
            v-if="favorite.favorite && favorite.favorite.length ? favorite.favorite[0].type === 'event' : false"
            :postData="{
              ...favorite.favorite[0],
              content_type: favorite.favorite[0].type,
              postId: favorite.favorite[0].id,
              sponsered: favorite.favorite[0].sponsered ? favorite.favorite[0].sponsered : [],
              user: [favorite.favorite[0].user],
              allow_comments: favorite.favorite[0].allow_comments ? favorite.favorite[0].allow_comments : true,
            }"
            v-on:refresh="fetchEvent()"
            :fetchPosts="fetchEvent"
            :handleOtherModals="handleOtherModals"
            :fromProfileSaved="true"
          />
        </div>
        <span
          class="viewmore cp"
          v-if="favoriteEvent && favoriteEvent.length < paginationEvent.total_count"
          :style="{ color: getPrimaryColor(), textAlign: 'center', display: 'block' }"
          @click="fetchEvent(true)"
        >
          More Events
        </span>
      </div>
      <div v-if="!loadingEvent && favoriteEvent && favoriteEvent.length === 0">
        <div class="dailogbox">
          <div class="dailog-wrapper">
            <span class="dailog">
              <span class="dailog text-capitalize">
                {{
                  viewUser.role === "hospital"
                    ? viewUser.hospital_info.hospital_name
                    : viewUser.role === "clinic"
                    ? viewUser.clinic_info.clinic_name
                    : viewUser.doctor_info
                    ? viewUser.doctor_info.full_name
                    : viewUser.display_name
                }}
              </span>
              has not saved any events yet.
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- PressRelease -->
    <div>
      <h3 class="title">Saved Press Releases</h3>
      <div v-if="loadingPressRelease" class="d-flex justify-content-center">
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div v-if="!loadingPressRelease && favoritePressRelease && favoritePressRelease.length">
        <div v-for="(favorite, index) in favoritePressRelease" :key="index">
          <FavPost
            v-if="favorite.favorite && favorite.favorite.length ? favorite.favorite[0].type === 'pressRelease' || favorite.favorite[0].type === 'press' : false"
            :postData="{
              ...favorite.favorite[0],
              content_type: favorite.favorite[0].type,
              postId: favorite.favorite[0].id,
              sponsered: favorite.favorite[0].sponsered ? favorite.favorite[0].sponsered : [],
              user: [favorite.favorite[0].user],
              allow_comments: favorite.favorite[0].allow_comments ? favorite.favorite[0].allow_comments : true,
            }"
            v-on:refresh="fetchPressRelease()"
            :fetchPosts="fetchPressRelease"
            :handleOtherModals="handleOtherModals"
            :fromProfileSaved="true"
          />
        </div>
        <span
          class="cp viewmore"
          v-if="favoritePressRelease && favoritePressRelease.length < paginationPressRelease.total_count"
          :style="{ color: getPrimaryColor(), textAlign: 'center', display: 'block' }"
          @click="fetchPressRelease(true)"
        >
          More Press Releases
        </span>
      </div>
      <div v-if="!loadingPressRelease && favoritePressRelease && favoritePressRelease.length === 0">
        <div class="dailogbox">
          <div class="dailog-wrapper">
            <span class="dailog">
              <span class="dailog text-capitalize">
                {{
                  viewUser.role === "hospital"
                    ? viewUser.hospital_info.hospital_name
                    : viewUser.role === "clinic"
                    ? viewUser.clinic_info.clinic_name
                    : viewUser.doctor_info
                    ? viewUser.doctor_info.full_name
                    : viewUser.display_name
                }}
              </span>
              has not saved any press releases yet.
            </span>
          </div>
        </div>
      </div>
    </div>

    <PostFullScreen ref="PostFullScreen" :postData="currentPostData" />
    <CreateNewPostModal ref="CreateNewPostModal" :getPost="fetch" :showCongrats="showCongrats" :handleOtherModals="handleOtherModals" />
    <congrats :showInfoModal="showInfoModal" ref="Congrats" />
    <info ref="Info" />
    <createEvent ref="EventModal" :handleOtherModals="handleOtherModals" />
    <createJob ref="JobModal" :handleOtherModals="handleOtherModals" />
    <createPressRelease ref="PressModal" :handleOtherModals="handleOtherModals" />
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import FavPost from "../../../home/Post"
import CreateNewPostModal from "../../../Modals/CreateNewPost.vue"
import Congrats from "../../../Modals/activity/Congrats.vue"
import Info from "../../../Modals/activity/Info.vue"
import createEvent from "../../../Modals/createEvent.vue"
import createJob from "../../../Modals/createJob.vue"
import createPressRelease from "../../../Modals/createPressRelease.vue"
import Question from "../../Patient/QA/Question"
import UserPollCard from "../../../home/poll/UserPollCard.vue"
import PostFullScreen from "../../../Modals/activity/PostFullScreen.vue"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "PatientFavorites",
  components: {
    FavPost,
    Question,
    UserPollCard,
    PostFullScreen,
    createEvent,
    createJob,
    createPressRelease,
    Congrats,
    CreateNewPostModal,
    Info,
  },
  data() {
    return {
      favorites: [],
      favoritePost: [],
      favoriteQA: [],
      favoriteJob: [],
      favoriteEvent: [],
      favoritePressRelease: [],
      paginationPost: null,
      paginationQA: null,
      currentPagePost: 2,
      currentPageQA: 2,
      currentPageJob: 2,
      currentPageEvent: 2,
      currentPagePressRelease: 2,
      paginationJob: null,
      paginationEvent: null,
      paginationPressRelease: null,
      pagination: null,
      currentPage: 2,
      limit: 5,
      loadingpost: true,
      loadingpoll: true,
      loadingqa: true,
      loadingJob: true,
      loadingEvent: true,
      loadingPressRelease: true,
      showNo: false,
    }
  },

  created() {
    console.warn("ViewPatientFavorites.vue created")
    this.fetchPost()
    this.fetchQA()
    this.fetchPoll()
    this.fetchJob()
    this.fetchEvent()
    this.fetchPressRelease()
  },

  methods: {
    handleOtherModals(modalToOpen, data = null, type = "post", editing = false, tags = [], id) {
      console.log("handleOtherModals ->", modalToOpen)
      console.log("editing ->", editing)
      console.log("data ->", data)
      // this.$refs.CreateNewPostModal.hide()
      switch (modalToOpen) {
        case "pressRelease":
        case "press":
          this.$refs.PressModal.show(data, editing, tags, id)
          break
        case "job":
          this.$refs.JobModal.show(data, editing, tags, id)
          break
        case "event":
          this.$refs.EventModal.show(data, editing, tags, id)
          break
        case "add":
        case "new":
        case "edit":
          this.$refs.CreateNewPostModal.show(editing ? "edit" : "add", data, type, tags, id)
          break
        case "more":
        case "back":
        case "moreOptions":
          this.$refs.CreateNewPostModal.show("more", data, type, tags, id)
          break
      }
    },

    showCongrats() {
      this.$refs.Congrats.show()
    },
    showInfoModal() {
      this.$refs.Info.show()
    },
    pushToHome() {
      this.$router.push({ name: "ActivityHome" })
    },

    fetchPost(append = false) {
      if (append) {
        UserRepository.getFavoritesPost(this.currentPagePost, this.limit, this.currentCircle.id, this.viewUser).then(res => {
          this.favoritePost.push(...res.data.data.data)
          this.paginationPost = res.data.data.paginator ? res.data.data.paginator : {}
          this.currentPagePost += 1
        })
      } else {
        this.loadingpost = true
        this.favoritePost = []
        UserRepository.getFavoritesPost(1, this.limit, this.currentCircle.id, this.viewUser).then(res => {
          if (res.data) {
            this.loadingpost = false
            this.favoritePost = res.data.data.data ? res.data.data.data : []
            this.loadingpost = false
            this.paginationPost = res.data.data.paginator ? res.data.data.paginator : {}
          }
        })
      }
    },

    fetchQA(append = false) {
      if (append) {
        UserRepository.getFavoritesQA(this.currentPageQA, this.limit, this.currentCircle.id, this.viewUser).then(res => {
          this.favoriteQA.push(...res.data.data.data)
          this.paginationQA = res.data.data.paginator ? res.data.data.paginator : {}
          this.currentPageQA += 1
          console.log("saved QA:", this.favoriteQA)
        })
      } else {
        this.loadingqa = true
        this.favoriteQA = []
        UserRepository.getFavoritesQA(1, this.limit, this.currentCircle.id, this.viewUser).then(res => {
          if (res.data) {
            this.loadingqa = false
            this.favoriteQA = res.data.data.data || []
            this.loadingqa = false
            this.paginationQA = res.data.data.paginator || {}
          }
          console.log("saved QA:", this.favoriteQA)
        })
      }
    },

    fetchPoll(append = false) {
      if (append) {
        UserRepository.getFavoritesPolls(this.currentPagePoll, this.limit, this.currentCircle.id, this.viewUser).then(res => {
          this.favoritePoll.push(...res.data.data.data)
          this.paginationPoll = res.data.data.paginator ? res.data.data.paginator : {}
          this.currentPagePoll += 1
        })
      } else {
        this.loadingpoll = true
        this.favoritePoll = []
        UserRepository.getFavoritesPolls(1, this.limit, this.currentCircle.id, this.viewUser).then(res => {
          if (res.data) {
            this.loadingpoll = false
            this.favoritePoll = res.data.data.data ? res.data.data.data : []
            this.loadingpoll = false
            this.paginationPoll = res.data.data.paginator ? res.data.data.paginator : {}
          }
        })
      }
    },

    fetchJob(append = false) {
      if (append) {
        UserRepository.getFavoritesJobs(this.currentPageJob, this.limit, this.currentCircle.id, this.viewUser).then(res => {
          this.favoriteJob.push(...res.data.data.data)
          this.paginationJob = res.data.data.paginator ? res.data.data.paginator : {}
          this.currentPageJob += 1
        })
      } else {
        this.loadingJob = true
        this.favoriteJob = []
        UserRepository.getFavoritesJobs(1, this.limit, this.currentCircle.id, this.viewUser).then(res => {
          if (res.data) {
            this.loadingJob = false
            this.favoriteJob = res.data.data.data ? res.data.data.data : []
            this.loadingJob = false
            this.paginationJob = res.data.data.paginator ? res.data.data.paginator : {}
          }
        })
      }
    },

    fetchEvent(append = false) {
      if (append) {
        UserRepository.getFavoritesEvents(this.currentPageEvent, this.limit, this.currentCircle.id, this.viewUser).then(res => {
          this.favoriteEvent.push(...res.data.data.data)
          this.paginationEvent = res.data.data.paginator ? res.data.data.paginator : {}
          this.currentPageEvent += 1
        })
      } else {
        this.loadingEvent = true
        this.favoriteEvent = []
        UserRepository.getFavoritesEvents(1, this.limit, this.currentCircle.id, this.viewUser).then(res => {
          if (res.data) {
            this.loadingEvent = false
            this.favoriteEvent = res.data.data.data ? res.data.data.data : []
            this.loadingEvent = false
            this.paginationEvent = res.data.data.paginator ? res.data.data.paginator : {}
          }
        })
      }
    },

    fetchPressRelease(append = false) {
      if (append) {
        UserRepository.getFavoritesPressReleases(this.currentPagePressRelease, this.limit, this.currentCircle.id, this.viewUser).then(res => {
          this.favoritePressRelease.push(...res.data.data.data)
          this.paginationPressRelease = res.data.data.paginator ? res.data.data.paginator : {}
          this.currentPagePressRelease += 1
        })
      } else {
        this.loadingPressRelease = true
        this.favoritePressRelease = []
        UserRepository.getFavoritesPressReleases(1, this.limit, this.currentCircle.id, this.viewUser).then(res => {
          if (res.data) {
            this.loadingPressRelease = false
            this.favoritePressRelease = res.data.data.data ? res.data.data.data : []
            this.loadingPressRelease = false
            this.paginationPressRelease = res.data.data.paginator ? res.data.data.paginator : {}
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.contq {
  display: flex;
  gap: 80px;
  flex-direction: column;
}

.viewmore {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 4px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 20px;
  background: #f1f5f9;
  border-radius: 8px;
}

.get-started-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  height: 48px;
  background: #062b54;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  text-transform: capitalize;
  color: #ffffff;
  border: none;
}

.dailog {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #33415f;
}

.dailog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
  // height: 115px;
}

.dailogbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  // height: 163px;
  background: #f1f5f9;
  border-radius: 8px;
}

.title {
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  margin-bottom: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Patient/view/ViewPatientFavorites.vue